import { put } from 'redux-saga/effects'

import { Pap } from 'services/api/entities'
import { PapActionCreators } from 'app/reducers/PapRedux'

export function* getPapStatusRequest() {
  const response = yield Pap.status()

  if (response.success()) {
    return yield put(PapActionCreators.getPapStatusSuccess(response.data))
  }
  yield put(PapActionCreators.getPapStatusFailure(response.data))
}

export function* getPapDealsRequest({ params }) {
  const response = yield Pap.myDeals(params)

  if (response.success()) {
    const { count, results } = response.data
    return yield put(PapActionCreators.getPapDealsSuccess(count, results))
  }
  yield put(PapActionCreators.getPapDealsFailure(response.data))
}

export function* getPapPeriodsRequest() {
  const response = yield Pap.periods()

  if (response.success()) {
    // the endpoint answers a bare array; tolerate a paginated envelope so a
    // future pagination_class does not blank the walker
    const { data } = response
    const periods = Array.isArray(data) ? data : (data && data.results) || []
    return yield put(PapActionCreators.getPapPeriodsSuccess(periods))
  }
  yield put(PapActionCreators.getPapPeriodsFailure(response.data))
}

export function* getPapClosingsRequest({ params }) {
  const response = yield Pap.closings(params)

  if (response.success()) {
    return yield put(PapActionCreators.getPapClosingsSuccess(response.data))
  }
  // `Response` stamps the HTTP status on the error body — the reducer reads
  // it to tell "not deployed yet" (404) from a real failure
  yield put(PapActionCreators.getPapClosingsFailure(response.data))
}

export function* getPapLedgerRequest({ params }) {
  const response = yield Pap.ledger(params)

  if (response.success()) {
    const { count, results } = response.data
    return yield put(PapActionCreators.getPapLedgerSuccess(count, results))
  }
  yield put(PapActionCreators.getPapLedgerFailure(response.data))
}
